import { useState, useCallback } from "react";
import ModalPopup from "../components/ModalPopup";

export function useChooseModal() {
  const [modalState, setModalState] = useState({
    isOpen: false,
    title: "",
    message: "",
    options: [],
    resolve: null,
  });
  const [selectedValue, setSelectedValue] = useState(null);

  const choose = useCallback((title, message, options) => {
    return new Promise((resolve) => {
      setModalState({
        isOpen: true,
        title,
        message,
        options, // array เช่น [{ label: "A", value: "a" }, ...]
        resolve,
      });
    });
  }, []);

  const content = (
    <div>
      <label>{modalState.message}</label>
      <div className="flex flex-col gap-y-2">
        {modalState.options.map((el) => (
          <label
            style={{
              backgroundColor:
                selectedValue === el.value
                  ? "var(--secondary)"
                  : "var(--bright)",
              color:
                selectedValue === el.value ? "var(--bright)" : "var(--primary)",
            }}
            className="text-center border rounded-lg w-full py-2 px-8 hover:shadow-md cursor-pointer"
            key={el.value}
            onClick={() => setSelectedValue(el.value)}
          >
            {el.label}
          </label>
        ))}
      </div>
    </div>
  );

  const handleYes = () => {
    modalState.resolve(selectedValue);
    setSelectedValue(null);
    setModalState({ ...modalState, isOpen: false });
  };

  const handleNo = () => {
    modalState.resolve(null);
    setSelectedValue(null);
    setModalState({ ...modalState, isOpen: false });
  };

  const ChooseModal = (
    <ModalPopup
      titleName={modalState.title}
      content={content}
      isOpen={modalState.isOpen}
      onClose={handleNo}
      onNo={handleNo}
      onYes={handleYes}
    />
  );

  return { choose, ChooseModal };
}
